export default __webpack_public_path__ + "static/media/title.7a852169.png";